import styled from 'styled-components';

import * as Server from 'assets/js/Server';
import * as Common from 'assets/js/Common';
import {sendGet} from "assets/js/Server";
import {useEffect, useState} from "react";

export default function CheckListRetrieve() {

  //검색 조건
  const [searchParam, setSearchParam] = useState({
    custMstSeq: '',
    searchDt: ''
  });
  const changeSearchDt = date => {
    setSearchParam(() => {
      return {
        ...searchParam,
        searchDt: date
      }
    })
  }
  const [clientList, setClientList] = useState([]);
  const getClientList = () => {
    Server.sendGet('client/select', {}, getClientListCallback).then();
  }
  const getClientListCallback = res => {
    setClientList(res['resultList']);
  }
  const changeClient = custMstSeq => {
    setSearchParam(() => {
      return {
        ...searchParam,
        custMstSeq: custMstSeq
      }
    })
  }
  useEffect(() => {
    getClientList();
  }, []);

  //조회
  const [checkList, setCheckList] = useState([{
    seq: '',
    custMstSeq: '',
    checkName: '',
    qrCodeName: '',
    qrCode: '',
    stateList: [{
      checkName: '',
      fkWorkerId: '',
      workerName: '',
      state: false,
    }],
  }]);
  const [commuteList, setCommuteList] = useState([]);
  const getCheckListState = () => {
    if(searchParam.custMstSeq === '') {
      Common.errorMsg('고객사를 선택해주세요.');
      return;
    } else if(searchParam.searchDt === '') {
      Common.errorMsg('조회 날짜를 선택해주세요.');
      return;
    }
    sendGet(
      'client/check/list/state',
      searchParam,
      getCheckListStateCallback
    ).then()
  }
  const getCheckListStateCallback = res => {
    const resultObject = res['resultObject'];
    setCheckList(resultObject['checkList']);
    setCommuteList(resultObject['commuteList'])
  }

  return (
    <ContentWrap>
      <div className='content-inner'>
        {/* 타이틀 */}
        <div className='title'>
          <div className='title-head'>
            <i/>
            <h4>CheckList Retrieve</h4>
          </div>
        </div>
        {/* 컨텐츠 */}
        <div className='content'>
          <div className='util-box'>
            <div className='util-menu'>
              <select
                onChange={e => changeClient(e.target.value)}
              >
                <option value='default'>Select</option>
                {clientList?.map((item, idx) => (
                  <option value={item.custMstSeq}>{item.custName}</option>
                ))}
              </select>
              <input
                type='date'
                name='check-date'
                id='check-date'
                onChange={e => changeSearchDt(e.target.value)}
              />
            </div>
            <button
              className='search-btn'
              onClick={getCheckListState}
            >Search</button>
          </div>
          <div className='table-wrap'>
            <table>
              {commuteList?.length > 0 &&
                <>
                  <colgroup>
                    <col width='40%' />
                  </colgroup>
                  <thead>
                  <tr>
                    <th></th>
                    {commuteList?.map((item, idx) => (
                      <th>{item}</th>
                    ))}
                  </tr>
                  </thead>
                  <tbody>
                    {checkList?.map((item, idx) => (
                      <tr>
                        <td>{item.checkName}</td>
                        {item?.stateList?.map((state, idx) => (
                          <td>
                            {/*  name, id 각각의 작업자 고유명 or 번호로 통일 */}
                            <input
                              type='checkbox'
                              disabled={true}
                              checked={state.state === 'Y'}
                            />
                            <label htmlFor='test1'/>
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </>
              }
              {commuteList?.length === 0 &&
                <tfoot>
                  <tr>
                    <td>There is no data to output.</td>
                  </tr>
                </tfoot>
              }
            </table>
          </div>
        </div>
      </div>
    </ContentWrap>
  )
}

const ContentWrap = styled.div`
  position:relative;
  flex:1;
  background:#fff;
  font-family: 'Apple SD Gothic Neo', sans-serif;
  
  .content-inner {
    position:relative;
    
    .content {
      height: auto !important;
      
      .util-button {
        position:relative;
        display:flex;
        justify-content: flex-end;
        align-items:center;
        gap:0 10px;
        
        .util-btn {
          padding:0 20px;
          height:40px;
          line-height:40px;
          font-weight:600;
          font-size:14px;
          color:#ffffff;
          background:#a5a5a5;
          border-radius:4px;
          
          &.primary {
            background:#056eae;
          }
        }
      }
      
      .table-wrap {
        margin-top:30px;
        position:relative;
        max-height:567px;
        overflow-y:auto;
        display:flex;
        gap:0 100px;
        
        table {
          position:relative;
          border-collapse:separate;
          border-spacing:0;
          border-bottom:1px solid #111111;
          
          th {
            position:sticky;
            top:0;
            left:0;
            padding:15px 0;
            background:#eaeaea;
            font-weight:500;
            font-size:16px;
            color:#111111;            
            border-top:1px solid #717171;
            border-bottom:1px solid #717171;
          }
          
          tfoot td {
            padding: 240px 0;
            font-weight:600;
            font-size:18px;
          }
          
          td {
            padding:15px 0;
            font-weight:500;
            font-size:14px;
            color:#111111;
            text-align:center;
            vertical-align: middle;
            height:60px;
            
            button {
              padding:0 10px;
              height:30px;
              line-height:30px;
              font-size:14px;
              font-weight:400;
              color:#ffffff;
              background:#bcbcbc;
              border-radius:4px;
            }
          }
          
          tr + tr td {
            border-top:1px solid #717171;
          }
        }
      }
    }
  }
`


